<template>
  <div class="content">
    <Header :title="'我的关注'" />
    <div class="cards-follow">
      <!-- <nut-infiniteloading
        @loadmore="onInfinite"
        :is-show-mod="true"
        :has-more="isHasMore"
        :is-loading="isLoading"
        :threshold="200"
      >-->
      <ul v-show="list.length">
        <li v-for="(item,index) in list" :key="index" @click="toHall(item.id)">
          <div class="card-wrap">
            <div class="img-wrap">
              <img
                :src="$resUrl(item.picture)"
                alt
                @error="$defImg(require('@/assets/images/avatar-default.png'))"
              >
            </div>
            <div class="is-follow" @click.stop="isFollow(item)">
              <div class="btn-wrap">
                <i class="iconfont">&#xe83b;</i>
                已关注
              </div>
            </div>
            <div class="txt-wrap">
              <h3>
                <span class="hall-name">{{ item.memorialHallName }}</span>
                <span class="hall-level">[{{ item.memorialHallLevel }}]</span>
              </h3>
              <div class="hall-wrap">
                馆号：{{ item.memorialHallNumber }}
                <div class="worship">
                  <router-link to="/">
                    <i class="iconfont color-red">&#xe669;</i>
                    祭拜
                    <span class="color-red num">{{ item.sacrificeCount }}</span>
                  </router-link>
                </div>
              </div>
              <p>生卒年：{{ item.birthDate }} - {{ item.deadDate }}</p>
            </div>
          </div>
        </li>
      </ul>
      <!-- </nut-infiniteloading> -->
      <div v-show="!list.length" class="no-data">您还没有关注任何纪念馆哦！</div>
      <nut-backtop :bottom="70" :duration="1000" :right="10" :z-index="10">
        <i class="iconfont back-top">&#xe66a;</i>
      </nut-backtop>
    </div>
    <!--弹窗-是否取消关注 -->
    <my-dialog
      v-if="dialogShow"
      cancel="取消"
      confirm="确定"
      title="确认取消关注？"
      @close="closeDialog"
      @submit="submitDialog"
    />
    <Footer :active="4" />
  </div>
</template>
<script>
import { Toast } from '@nutui/nutui'
import { isFollow, myFollow } from '@/api/Personal/index'
import Header from '@/components/Header/Index'
import Footer from '@/components/Footer/Index'
import MyDialog from '@/components/MyDialog/Index'
import { notificationList } from '@/api/Personal/Message'

export default {
  name: 'Follow',
  components: {
    Header,
    Footer,
    MyDialog
  },
  data() {
    return {
      dialogShow: false,
      isHasMore: true,
      isLoading: false,
      isErr: false,
      pageIndex: 0,
      pageSize: 10,
      total: 0,
      list: [],
      followId: ''
    }
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      myFollow().then(res => {
        if (res && res.success) {
          if (res.data) {
            this.list = res.data
            this.list.forEach(item => {
              if (item.memorialHallLevel === 4) {
                item.memorialHallLevel = '普通馆'
              }
              if (item.memorialHallLevel === 2) {
                item.memorialHallLevel = '尊享馆'
              }
              if (item.memorialHallLevel === 1) {
                item.memorialHallLevel = '豪华馆'
              }
            })
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    isFollow(item) {
      this.dialogShow = true
      this.followId = item.id
    },
    // --确认--取消关注
    submitDialog() {
      this.dialogShow = false
      isFollow(this.followId).then(res => {
        if (res && res.success) {
          Toast.success('已取消关注')
        } else {
          Toast.fail('取消关注失败')
        }
        this.initPage()
      })
    },
    // --取消--取消关注
    closeDialog() {
      this.dialogShow = false
    },
    toHall(id) {
      this.$router.push({
        name: 'HallIndex',
        params: {
          id: id
        }
      })
    },
    // 分页加载
    onInfinite() {
      this.isLoading = true
      const pageNum = Math.ceil(this.total / this.pageSize)
      if (this.pageIndex <= pageNum) {
        const params = {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
        notificationList(params).then(res => {
          if (res && res.success) {
            if (res.data) {
              if (res.data.rows) {
                this.list = res.data
                this.list.forEach(item => {
                  if (item.memorialHallLevel === 4) {
                    item.memorialHallLevel = '普通馆'
                  }
                  if (item.memorialHallLevel === 2) {
                    item.memorialHallLevel = '尊享馆'
                  }
                  if (item.memorialHallLevel === 1) {
                    item.memorialHallLevel = '豪华馆'
                  }
                })
              }
            }
          } else {
            Toast.fail(res.msg)
          }
        })
        this.pageIndex = this.pageIndex + 1
      } else {
        this.isHasMore = false
      }
      this.isLoading = false
    }
  }
}
</script>
<style lang='scss' scoped>
@import '@/styles/index.scss';

::v-deep .nut-dialog-ok {
  background: #dda82a;
}

.content {
  width: 100vw;
  min-height: 0;
  height: auto;
  overflow: hidden;
  box-sizing: border-box;
  padding: 15px 15px 80px 15px;

  .cards-follow {
    width: 100%;
    min-height: 0;
    height: auto;
    overflow: hidden;
    box-sizing: border-box;
    padding-bottom: 30px;

    ul {
      margin: 0;
      padding: 0;

      li {
        width: calc(100% - 10px);
        height: 110px;
        margin: 10px auto;
        border-radius: 5px;
        overflow: hidden;
        background: #ffffff;
        position: relative;
        padding: 16px;
        box-sizing: border-box;
        @extend %boxShadow;

        .img-wrap {
          width: 75px;
          height: 75px;
          overflow: hidden;
          border-radius: 3px;
          position: absolute;
          top: 16px;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .is-follow {
          width: 70px;
          height: 25px;
          line-height: 25px;
          position: absolute;
          right: 16px;
          top: 16px;
          font-size: 12px;
          z-index: 9;

          .btn-wrap {
            width: 100%;
            height: 25px;
            @extend %colorGrident;
            border-radius: 25px;
            overflow: hidden;
            text-align: center;
            color: #ffffff;
            box-sizing: border-box;

            .iconfont {
              font-size: 14px;
            }

            &.active {
              color: #dda82a;
              border: 1px solid #dda82a;
              background: #ffffff;
            }
          }
        }

        .txt-wrap {
          width: 100%;
          box-sizing: border-box;
          height: 100%;
          padding: 0 0 0 85px;

          h3 {
            color: #333333;
            font-size: 18px;
            text-align: left;
            box-sizing: border-box;
            margin: 0;
            padding: 0 80px 0 0;
            position: relative;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;

            .hall-name {
              display: block;
              max-width: calc(100% - 60px);
              box-sizing: border-box;
              position: relative;
              @extend %ellipsis;
            }

            .hall-level {
              color: #b2b2b2;
              font-size: 12px;
              font-weight: normal;
              position: relative;
            }
          }

          .hall-wrap {
            font-size: 12px;
            text-align: left;
            width: 100%;
            height: 30px;
            line-height: 30px;
            box-sizing: border-box;
            padding: 0 90px 0 0;
            position: relative;
            color: #adadad;
            @extend %ellipsis;

            .worship {
              width: auto;
              max-width: 90px;
              height: 30px;
              line-height: 30px;
              @extend %ellipsis;
              position: absolute;
              right: 0;
              top: 0;

              a {
                display: block;
                width: 100%;
                height: 100%;
                color: #adadad;

                .color-red {
                  color: #ff5c2a;

                  &.num {
                    font-weight: 600;
                  }
                }
              }
            }
          }

          p {
            margin: 0;
            padding: 0;
            font-size: 12px;
            color: #adadad;
            text-align: left;
            @extend %ellipsis;
          }
        }
      }
    }

    .no-data {
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 13px;
      color: #999999;
    }

    .back-top {
      font-size: 45px;
      color: #d08d03;
    }
  }
}
</style>
